module.exports = __webpack_public_path__ + "img/vue.c43ccc31.png";